import React from 'react';

const RadioField = ({ label, defaultValue, options, value, onChange, name, register, rules }) => {
  return (
    <div className='mb-3 flex w-full'>
      <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>{label}</label>
      <div className='flex flex-col w-full max-w-xs'>
        {options.map((option) => (
            <label key={option.value} className="flex items-center mb-2">
              <input
                type="radio"
                name={name} // Optional name for grouping
                className="mr-2"
                {...register(name, {
                  ...rules,
                  value: defaultValue, // Register the field with the default value
                })}
                value={option.value}
                defaultChecked={option.value === defaultValue}
              />
              {option.label}
            </label>
        ))}
      </div>
    </div>
  );
};

export default RadioField;